<template>
  <div class="no-data">
    {{ $t("暫無數據") }}
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.no-data {
  font-size: 40px;
  text-align: center;
  padding: 150px;
  color: #a8aeb3;
  @media only screen and (max-width: 900px) {
    font-size: 24px;
    letter-spacing: 2px;
  }
}
</style>
